import { ErrorReason, ErrorStatus } from '@tink/core/src/tinkLinkErrorCodes';
import qs from 'query-string';
import { ApplicationError } from '../components/ApplicationErrorBoundary/errors/ApplicationError';
import { ajaxRetry } from '../lib-api/ajaxRetry';
import { base, createApiURL, ResponseObj } from '../lib-api/services/base';
import { AccountsV2Entity, AccountV2Type } from '../payments/models/accounts-v2';

export const ERR_FAILED_TO_FETCH_ACCOUNTS = {
  errorStatus: ErrorStatus.INTERNAL_ERROR,
  errorReason: ErrorReason.REQUEST_FAILED_FETCH_ACCOUNTS,
};

export type AccountsV2QueryParams = {
  typesIn?: Exclude<AccountV2Type, AccountV2Type.UNDEFINED>[];
};

export interface AccountsV2Service {
  fetchAccounts: (queryParams?: AccountsV2QueryParams) => Promise<AccountsV2Entity>;
}

export interface AccountsV2Client {
  fetchAccounts: (queryParams?: AccountsV2QueryParams) => Promise<ResponseObj<AccountsV2Entity>>;
}

export const accountsV2Client: AccountsV2Client = {
  fetchAccounts: (queryParams: AccountsV2QueryParams = {}) => {
    const { typesIn } = queryParams;

    const query = qs.stringify({ typesIn });

    return ajaxRetry<AccountsV2Entity>({
      headers: base.headers(),
      method: 'GET',
      url: createApiURL(`/data/v2/accounts?${query.toString()}`),
    });
  },
};

export function createAccountsV2Service(client: AccountsV2Client): AccountsV2Service {
  return {
    fetchAccounts: async (queryParams?: AccountsV2QueryParams): Promise<AccountsV2Entity> => {
      const response = await client.fetchAccounts(queryParams);

      if (!response.isOk() || !response.data) {
        throw new ApplicationError(ERR_FAILED_TO_FETCH_ACCOUNTS);
      }

      return {
        accounts: response.data?.accounts,
      };
    },
  };
}

export const accountsV2Service = createAccountsV2Service(accountsV2Client);
